const faqs = [
    {
        id: 1,
        category : 'About hotel',
        questions : [
            {
                id: 1,
                question : 'What is Lorem Ipsum?',
                answer : 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.'
            },
            {
                id: 2,
                question : 'Where does it come from?',
                answer : 'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.'
            },
            {
                id: 3,
                question : 'Why do we use it?',
                answer : 'Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for \'lorem ipsum\' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).'
            },
            {
                id: 4,
                question : 'Lorem ipsum dolor sit amet?',
                answer : 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Vero hic pariatur temporibus doloribus a dicta cumque rerum sint quo officia.'
            },
            {
                id: 5,
                question : 'Where does it come from?',
                answer : 'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.'
            },
        ]
    },
    {
        id: 2,
        category : 'About Beach',
        questions : [
            {
                id: 6,
                question : 'What is Lorem Ipsum?',
                answer : 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.'
            },
            {
                id: 7,
                question : 'Where does it come from?',
                answer : 'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.'
            },
            {
                id: 8,
                question : 'Why do we use it?',
                answer : 'Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for \'lorem ipsum\' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).'
            },
            {
                id: 9,
                question : 'Lorem ipsum dolor sit amet?',
                answer : 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Vero hic pariatur temporibus doloribus a dicta cumque rerum sint quo officia.'
            },
            {
                id: 10,
                question : 'Where does it come from?',
                answer : 'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.'
            },
        ]
    },
    {
        id: 3,
        category : 'Services',
        questions : [
            {
                id: 11,
                question : 'What is Lorem Ipsum?',
                answer : 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.'
            },
            {
                id: 12,
                question : 'Where does it come from?',
                answer : 'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.'
            },
            {
                id: 13,
                question : 'Why do we use it?',
                answer : 'Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for \'lorem ipsum\' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).'
            },
            {
                id: 14,
                question : 'Lorem ipsum dolor sit amet?',
                answer : 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Vero hic pariatur temporibus doloribus a dicta cumque rerum sint quo officia.'
            },
            {
                id: 15,
                question : 'Where does it come from?',
                answer : 'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.'
            },
            {
                id: 16,
                question : 'Why do we use it?',
                answer : 'Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for \'lorem ipsum\' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).'
            },
        ]
    },
    {
        id: 4,
        category : 'Payments',
        questions : [
            {
                id: 17,
                question : 'What is Lorem Ipsum?',
                answer : 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.'
            },
            {
                id: 18,
                question : 'Where does it come from?',
                answer : 'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.'
            },
            {
                id: 19,
                question : 'Why do we use it?',
                answer : 'Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for \'lorem ipsum\' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).'
            },
            {
                id: 20,
                question : 'Lorem ipsum dolor sit amet?',
                answer : 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Vero hic pariatur temporibus doloribus a dicta cumque rerum sint quo officia.'
            },
            {
                id: 21,
                question : 'Where does it come from?',
                answer : 'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.'
            }
        ]
    },
    {
        id: 5,
        category : 'Terms and conditions',
        questions : [
            {
                id: 22,
                question : 'What is Lorem Ipsum?',
                answer : 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.'
            },
            {
                id: 23,
                question : 'Where does it come from?',
                answer : 'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.'
            },
            {
                id: 24,
                question : 'Why do we use it?',
                answer : 'Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for \'lorem ipsum\' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).'
            },
            {
                id: 25,
                question : 'Lorem ipsum dolor sit amet?',
                answer : 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Vero hic pariatur temporibus doloribus a dicta cumque rerum sint quo officia.'
            },
            {
                id: 26,
                question : 'Where does it come from?',
                answer : 'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.'
            }
        ]
    },
]

export default faqs